var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaptop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "18px",
    viewBox: "0 0 12 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/laptop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.03333333,12.4666667 C1.7124984,12.4666667 1.43784836,12.3524317 1.209375,12.1239583 C0.980901635,11.895485 0.866666667,11.6208349 0.866666667,11.3 L0.866666667,6.16666667 C0.866666667,5.84583173 0.980901635,5.5711817 1.209375,5.34270833 C1.43784836,5.11423497 1.7124984,5 2.03333333,5 L9.96666667,5 C10.2875016,5 10.5621516,5.11423497 10.790625,5.34270833 C11.0190984,5.5711817 11.1333333,5.84583173 11.1333333,6.16666667 L11.1333333,11.3 C11.1333333,11.6208349 11.0190984,11.895485 10.790625,12.1239583 C10.5621516,12.3524317 10.2875016,12.4666667 9.96666667,12.4666667 L2.03333333,12.4666667 Z M1.8,6.16666667 L1.8,11.3 C1.8,11.3631948 1.82309005,11.4178817 1.86927083,11.4640625 C1.91545162,11.5102433 1.97013857,11.5333333 2.03333333,11.5333333 L9.96666667,11.5333333 C10.0298614,11.5333333 10.0845484,11.5102433 10.1307292,11.4640625 C10.17691,11.4178817 10.2,11.3631948 10.2,11.3 L10.2,6.16666667 C10.2,6.10347191 10.17691,6.04878495 10.1307292,6.00260417 C10.0845484,5.95642338 10.0298614,5.93333333 9.96666667,5.93333333 L2.03333333,5.93333333 C1.97013857,5.93333333 1.91545162,5.95642338 1.86927083,6.00260417 C1.82309005,6.04878495 1.8,6.10347191 1.8,6.16666667 Z M0,12.9333333 L12,12.9333333 L12,13.6333333 C12,13.8277788 11.9020843,13.9930549 11.70625,14.1291667 C11.5104157,14.2652785 11.2750014,14.3333333 11,14.3333333 L1,14.3333333 C0.724998625,14.3333333 0.489584312,14.2652785 0.29375,14.1291667 C0.0979156875,13.9930549 0,13.8277788 0,13.6333333 L0,12.9333333 Z M6.58333333,13.6333333 C6.6611115,13.6333333 6.7,13.5944448 6.7,13.5166667 C6.7,13.4388885 6.6611115,13.4 6.58333333,13.4 L5.41666667,13.4 C5.3388885,13.4 5.3,13.4388885 5.3,13.5166667 C5.3,13.5944448 5.3388885,13.6333333 5.41666667,13.6333333 L6.58333333,13.6333333 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/laptop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\uF109",
    fill: "#797979",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon/color/gray",
    mask: "url(#mask-2)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.f3a6b3016fbf319305f629fcbcf937a9.svg";
export { ForwardRef as ReactComponent };